module.exports = __webpack_public_path__ + "static/media/www.infuvalle.com_.c0097c44.png";